import { FirestoreConverter } from '../../converter';
import { ClientUser, User } from '../user.class';

/**
 * The converter instance from / to player instance
 */
export const UserConverter: FirestoreConverter<User> = {
    fromFirestore: (snapshot: any, options: any): User => {
        const data = snapshot.data(options);
        return Object.assign(new User(), {
            _id: data.id,
            _username: data.username,
            _avatar: data.avatar,
            _firstAccess: data.firstAccess,
            _lastAccess: data.lastAccess,
            _email: data.email,
        });
    },
    toFirestore: (user: User): any => ({
        id: user.id,
        username: user.username,
        avatar: user.avatar,
        firstAccess: user.firstAccess,
        lastAccess: user.lastAccess,
        email: user.email,
    }),
};

/**
 * The converter instance from / to player instance
 */
export const ClientUserConverter: FirestoreConverter<ClientUser> = {
    fromFirestore: (snapshot: any, options: any): ClientUser => {
        const data = snapshot.data(options);

        return Object.assign(new ClientUser(), UserConverter.fromFirestore(snapshot, options), {
            _firstname: data.firstname,
            _lastname: data.lastname,
            _cover: data.cover,
            _sites: data.sites,
            // Lecture seule (pas recopié par toFirestore) : écrit une fois par ensureUser.
            _signupFlow: data.signupFlow,
        });
    },
    toFirestore: (user: ClientUser): any =>
        Object.assign(UserConverter.toFirestore(user), {
            _firstname: user.firstname,
            _lastname: user.lastname,
            _cover: user.cover,
            _sites: user._sites,
        }),
};
